	import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ErrorPopUpComponent',
    templateUrl: 'ErrorPopUpComponent.html',
    
})
export class ErrorPopUpComponent {
  
	constructor(
		private activeModal: NgbActiveModal,
		) {
		
	}

	@Input() public errorTitle: string = "Error";

	@Input() public errorBody: string = "";

	@Input() public errorStack: string = "";

	
	cancel() {
		this.activeModal.close();
	}
}
